module.exports = __webpack_public_path__ + "ff621b31.webp";